'use client';

import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
const Loading = () => {
  const [loadingPhrase, setLoadingPhrase] = useState('You got it, Boss.');
  const [frame, setFrame] = useState('');
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoadingPhrase('Coming right up...');
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);
  useEffect(() => {
    let A = 0,
      B = 0;
    const width = 80,
      height = 24;
    const interval = setInterval(() => {
      const zBuffer = Array(width * height).fill(0);
      const output = Array(width * height).fill(' ');
      for (let j = 0; j < 6.28; j += 0.07) {
        for (let i = 0; i < 6.28; i += 0.02) {
          const sinA = Math.sin(A),
            cosA = Math.cos(A);
          const sinB = Math.sin(B),
            cosB = Math.cos(B);
          const sinI = Math.sin(i),
            cosI = Math.cos(i);
          const sinJ = Math.sin(j),
            cosJ = Math.cos(j);
          const circleX = cosJ + 2; // radius offset
          const circleY = sinJ;
          const D = 1 / (sinI * circleX * sinA + circleY * cosA + 5);
          const t = sinI * circleX * cosA - circleY * sinA;
          const x = Math.floor(width / 2 + 30 * D * (cosI * circleX * cosB - t * sinB));
          const y = Math.floor(height / 2 + 15 * D * (cosI * circleX * sinB + t * cosB));
          const idx = x + y * width;
          const luminance = Math.floor(8 * ((circleY * sinA - sinI * cosJ * cosA) * cosB - sinI * cosJ * sinA - circleY * cosA - cosI * cosJ * sinB));
          if (y >= 0 && y < height && x >= 0 && x < width && D > zBuffer[idx]) {
            zBuffer[idx] = D;
            const chars = '.,-~:;=!*#$@';
            output[idx] = chars[Math.max(0, Math.min(chars.length - 1, luminance))];
          }
        }
      }
      // Slice output into rows with newline characters
      let result = '';
      for (let i = 0; i < height; i++) {
        result += output.slice(i * width, (i + 1) * width).join('') + '\n';
      }
      setFrame(result);
      A += 0.04;
      B += 0.02;
    }, 50);
    return () => clearInterval(interval);
  }, []);
  return <div className="h-full w-full flex flex-col gap-8 justify-center items-center absolute top-0 left-0" data-sentry-component="Loading" data-sentry-source-file="loading.tsx">
      <pre style={{
      fontFamily: 'monospace',
      lineHeight: '1em'
    }}>{frame}</pre>
      <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="loading.tsx">
        <motion.div key={loadingPhrase} className="mt-4 text-xl absolute bottom-1/4" initial={{
        opacity: 0,
        x: -40,
        y: 0
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: 40,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-sentry-element="unknown" data-sentry-source-file="loading.tsx">
          {loadingPhrase}
        </motion.div>
      </AnimatePresence>
    </div>;
};
export default Loading;